import { Product } from 'utils/api/Products/CatalogProduct'
import { useGetObjectTranslation } from 'utils/useGetObjectTranslation'

export const getProductName = (product?: Product) =>
  useGetObjectTranslation(product?.translation, 'name') ||
  product?.navision_name ||
  'Unfortunately this product is currently not available anymore'
